import { Link } from 'react-router-dom';

interface BackToHomeProps {
  /** Override the default `mb-10` spacing if you need a tighter or looser bottom margin. */
  className?: string;
  /** Strapi-driven label override. Falls back to the canonical German copy. */
  label?: string;
}

/**
 * Standard "Zurück zur Startseite" link rendered at the top of every non-home page.
 * Pulled out of the inline copy on the BHS-Modell page so all sub-pages share one
 * affordance for getting back to the home page (in addition to the brand logo click).
 */
export default function BackToHome({ className = 'mb-10', label }: BackToHomeProps) {
  return (
    <Link
      to="/"
      className={`group inline-flex items-center text-sm font-semibold text-[#8B1538] transition-colors hover:text-[#6B0F2A] lg:text-base ${className}`}
    >
      <i className="ri-arrow-left-line mr-2 flex h-4 w-4 items-center justify-center transition-transform group-hover:-translate-x-1"></i>
      {label || 'Zurück zur Startseite'}
    </Link>
  );
}
